// @flow
import React from 'react';
import {ItemBack} from 'modules/common/components/ItemBack';
import {LabelText} from 'modules/common/components/LabelText';
import './style.less';

type TProps = {
    className?: string,
    error?: boolean,
};

const TextInput = ({className, error, ...rest}: TProps) => {
    let fullClassName = 'text-input__input ';
    if (className) {
        fullClassName += className;
    }
    if (error) {
        fullClassName += ' error';
    }
    return (
        <div className="text-input">
            <ItemBack className="text-input__wrapper">
                <LabelText>
                    <input className={fullClassName} type="text" {...rest} />
                </LabelText>
            </ItemBack>
        </div>
    );
};

export default TextInput;
